import { LitElement, html, css } from 'lit';

export class CrusherCard extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .card {
      width: var(--crusher-card-width, auto);
      height: var(--crusher-card-height, auto);
      box-sizing: border-box;
      background: var(--crusher-card-bg);
      -webkit-backdrop-filter: var(--crusher-card-backdrop, none);
      backdrop-filter: var(--crusher-card-backdrop, none);
      border: var(--crusher-card-border-width, var(--crusher-component-border-weight)) solid var(--crusher-card-border);
      background-clip: padding-box;
      border-radius: var(--crusher-card-radius, var(--crusher-radius-lg));
      padding: var(--crusher-card-padding, var(--crusher-spacing-6));
      box-shadow: var(--crusher-card-shadow);
      transition: all var(--crusher-motion-duration-base) var(--crusher-motion-easing-inout);
      overflow: var(--crusher-card-overflow, hidden);
      cursor: var(--crusher-card-cursor, inherit);
    }

    .card:hover {
      transform: var(--crusher-card-hover-lift);
      box-shadow: var(--crusher-card-hover-shadow);
    }
  `;

  render() {
    return html`
      <div class="card" part="surface">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('crusher-card', CrusherCard);
